import { render, staticRenderFns } from "./linked-commerce-panel.vue?vue&type=template&id=1ec081a0&scoped=true"
import script from "./linked-commerce-panel.vue?vue&type=script&lang=js"
export * from "./linked-commerce-panel.vue?vue&type=script&lang=js"
import style0 from "./linked-commerce-panel.vue?vue&type=style&index=0&id=1ec081a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec081a0",
  null
  
)

export default component.exports